<div fxLayout="row" fxLayoutAlign="center center">
    <img src="../../../../assets/images/404.png" class="img">
</div>
<div fxLayout="row" fxLayoutAlign="center center">
    <button mat-raised-button color="primary" class="post-job" routerLink="/admin/login">
        <p class="font-weight-600 font-size-20 ">Back To Login Page</p>
    </button>
</div>